import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTheme } from '../../hooks/useTheme';
import TRANSLATIONS from '../../translations/translations@default.json';
import AOWeRecommendSmile from '../ProductCard/AOWeRecommendSmile';
import DealsGridViewProductCard from '../ProductCard/DealsGridViewProductCard/DealsGridViewProductcard@default';
import Store from '../Views/store/store';

const DealsWeRecommendPod = ({ featuredProducts }) => {
	const { products } = useSelector((state) => state);

	const theme = useTheme('weRecommend');

	return (
		featuredProducts > 0 && (
			<li
				data-testid="deals-we-recommend-pod"
				className={classnames('p-1 md:p-2 relative', {
					'w-full': featuredProducts === 2,
					'w-1/2': featuredProducts === 1,
				})}>
				<div
					className={classnames(
						'P-4 h-auto overflow-hidden pb-4 product-card px-2 rounded-lg',
						theme.background
					)}>
					<div className={classnames('text-title-lg py-4 px-2', theme.text)}>
						{TRANSLATIONS.productList.productCard.featuredProductFlag}
					</div>

					<AOWeRecommendSmile
						className="absolute top-0"
						style={{ transform: 'scale(2)', right: '140px' }}
						fill={theme.fill}
					/>

					<ul className="flex">
						{products.map(
							(product, index) =>
								index < featuredProducts && (
									<Store>
										<DealsGridViewProductCard
											{...{
												key: `dealsPod_${product.Code}`,
												index,
												product,
												featuredProducts,
											}}
										/>
									</Store>
								)
						)}
					</ul>
				</div>
			</li>
		)
	);
};

export default DealsWeRecommendPod;
